import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Field, Formik, Form, useFormikContext } from "formik";
import {
  CONVERT_BOOL,
  REQUIRED,
  SelectionField,
  TextField,
} from "../../Components/constants/field";
import {
  findByIdCity,
  getAllActiveCountries,
  getStatesByCountryID,
  insertCity,
  updateCity,
} from "../../slices/thunks";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../Components/Common/Loader";
import * as Yup from "yup";

const CreateCity = () => {
  const history = useNavigate();
  const { ID } = useParams();
  const dispatch = useDispatch();
  const {
    cityDetail: { form },
  } = useSelector((state) => state.City);
  const { countries, loading: CountryLoading } = useSelector(
    (state) => state.Country
  );
  const { countryWiseState } = useSelector((state) => state.State);

  useEffect(() => {
    dispatch(getAllActiveCountries());
  }, []);

  useEffect(() => {
    if (ID) {
      let params = {
        ID: ID,
      };
      dispatch(findByIdCity(params));
    }
  }, [ID]);

  const handleSubmit = (values) => {
    let obj = {
      ...values,
    };

    obj.IsActive = CONVERT_BOOL.test(obj?.IsActive);
    obj.CountryID = obj.CountryID ? +obj.CountryID : null;
    obj.StateID = obj.StateID ? +obj.StateID : null;

    if (obj?.ID) {
      dispatch(updateCity(obj)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history(`/city`);
        }
      });
    } else {
      delete obj?.ID;
      dispatch(insertCity(obj)).then((res) => {
        if (res.payload && res.payload.Status === 200) {
          history(`/city`);
        }
      });
    }
  };

  if (CountryLoading) {
    return <Loader />;
  }
  return (
    <div className="page-content">
      <Container fluid>
        <ToastContainer />
        <BreadCrumb title="City" pageTitle="City" />
        <Row>
          <Col xl={12}>
            <Card color="dark" outline>
              <CardHeader className="bg-light">
                <Row className="align-items-center">
                  <Col md="11">
                    <h4 className="card-title mb-0">
                      {ID ? "Update City" : " Create City"}
                    </h4>
                  </Col>
                  <Col md="1">
                    <Link to="/city">
                      <Button color="primary" block>
                        Back
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col lg={12}>
                    <Formik
                      enableReinitialize={true}
                      initialValues={form}
                      validationSchema={Yup.object({
                        CountryID: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable()
                          .required(REQUIRED),
                        StateID: Yup.number()
                          .transform((value) =>
                            Number.isNaN(value) ? null : value
                          )
                          .nullable()
                          .required(REQUIRED),
                        CityName: Yup.string()
                          .nullable(true)
                          .required(REQUIRED),
                      })}
                      onSubmit={handleSubmit}
                    >
                      {() => {
                        return (
                          <Form noValidate autoComplete="off">
                            <div>
                              <Row>
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="CountryID"
                                    >
                                      Country:
                                    </Label>
                                    <Field
                                      name="CountryID"
                                      id="CountryID"
                                      options={
                                        Array.isArray(countries) &&
                                        countries.map((country) => {
                                          return {
                                            value: Number(country.ID),
                                            label: country.CountryName,
                                          };
                                        })
                                      }
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="StateID"
                                    >
                                      State:
                                    </Label>
                                    <Field
                                      name="StateID"
                                      id="StateID"
                                      options={
                                        Array.isArray(countryWiseState) &&
                                        countryWiseState.map((state) => {
                                          return {
                                            value: Number(state.ID),
                                            label: state.StateName,
                                          };
                                        })
                                      }
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="CityName"
                                    >
                                      City:
                                    </Label>
                                    <Field
                                      name="CityName"
                                      className="form-control"
                                      id="CityName"
                                      placeholder="Enter City Name"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="CityCode"
                                    >
                                      City Code:
                                    </Label>
                                    <Field
                                      name="CityCode"
                                      className="form-control"
                                      id="CityCode"
                                      placeholder="Enter City Code"
                                      component={TextField}
                                    />
                                  </div>
                                </Col>{" "}
                                <Col lg={6}>
                                  <div className="mb-3">
                                    <Label
                                      className="form-label"
                                      htmlFor="IsActive"
                                    >
                                      Status
                                    </Label>
                                    <Field
                                      name="IsActive"
                                      id="IsActive"
                                      options={[
                                        {
                                          label: "Active",
                                          value: true,
                                        },
                                        {
                                          label: "Inactive",
                                          value: false,
                                        },
                                      ]}
                                      component={SelectionField}
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row className="mt-2">
                                <Col lg={12}>
                                  <hr></hr>
                                </Col>
                                <Col md="12" className="text-end">
                                  <Button type="submit" className="success">
                                    Save
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                            <CountryChangeWatcher />
                          </Form>
                        );
                      }}
                    </Formik>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const CountryChangeWatcher = () => {
  const { values } = useFormikContext();
  const dispatch = useDispatch();

  useEffect(() => {
    if (values.CountryID) {
      dispatch(getStatesByCountryID(values.CountryID));
    }
  }, [values.CountryID]);
  return null;
};

export default CreateCity;
